export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9166.f72ccf69.jpg";